import { render } from "./ValeurStocks.vue?vue&type=template&id=6bee69c4&scoped=true"
import script from "./ValeurStocks.vue?vue&type=script&lang=js"
export * from "./ValeurStocks.vue?vue&type=script&lang=js"

import "./ValeurStocks.vue?vue&type=style&index=0&id=6bee69c4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bee69c4"]])

export default __exports__